import { CircularProgress, Dialog, DialogContent, DialogTitle, Typography, makeStyles } from '@material-ui/core'
import FileUpload from 'components/form_components/fileUpload'
import React, { useEffect, useState } from 'react'
import { RemovedParts } from "lib/services/api/operaitons/lineMaintenance/Removedparts";


const useStyles = makeStyles((theme) => ({
    dialog: {
        "& .MuiDialog-paperWidthMd": {
            boxShadow: "0px 3px 6px #00000029",
            // position: "absolute",
            // left: "calc(50% - 250px)",
            width: '40%',
            height: '238px',
            borderRadius: '5px'
        }
    },
    dialogTitle: {
        color: theme.palette.primary.main,
        fontSize: '18px'
    }

}))

function DispatchFiles(props) {
    const classes = useStyles()
    const { handleClose, currentSelection } = props
    const [loading, setLoading] = useState(true)
    const [files, setFiles] = useState([])


    useEffect(() => {
        setLoading(true)
        const params = {
            dispatch_id: currentSelection?.dispatch
        }
        RemovedParts.getDispatchFiles(params).then((res) => {
            setFiles(res.data.files)
        }).catch(() => {

        }).finally(() => {
            setLoading(false)
        })
    }, [currentSelection])

    return (
        <div>
            <Dialog
                // fullWidth={true}
                maxWidth={'md'}
                open={true}
                onClose={handleClose}
                className={classes.dialog}
                aria-labelledby="dispatch-files">

                <DialogTitle ><Typography variant='subtitle2' className={classes.dialogTitle}> Dispatch Files </Typography> </DialogTitle>
                <DialogContent>

                    <FileUpload
                        isLoading={loading}
                        defaultValue={files !== undefined ? files.map((file) => ({
                            filename: file?.file_name,
                            url: file?.file_path,
                            id: file?.id,
                        })) : ''}
                        APIUrl={""}
                        showBorderOnNoFiles={false}
                        uploadButtonView={true}
                        multiple={true}
                        name={"maintenance_file"}
                        action={"Upload Document"} />

                </DialogContent>
            </Dialog>

        </div>
    )
}

export default DispatchFiles